import { IndicadoresExclusaoDados } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/indicadores/exclusao/dados',
    parent: '/indicadores',
    text: 'Exclusão de Dados',
    match: /\/indicadores\/exclusao\/dados+$/,
    sider: true,
    component: IndicadoresExclusaoDados,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
